import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { AppMainComponent } from "src/app/app.main.component";
import * as _ from "lodash";
import { DatePipe } from "@angular/common";
import { CreditMemoStatus, CustomAttributeFieldType, SOChannel, TemplateType } from "src/app/inventory/sales-order/constants/constants";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";
import { AppMainService } from "src/app/app-main.service";
import { ProductsService } from "src/app/inventory/products/products.service";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { ImportserialService } from "../../services/importserial.service";
import { Subject, takeUntil } from "rxjs";
import { AccountsTransactionType } from "src/app/finance/constants/constants";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: "app-credit-memo-overview",
    templateUrl: "./credit-memo-overview.component.html",
    styleUrls: ["./credit-memo-overview.component.scss"],
})
export class CreditMemoOverviewComponent implements OnChanges {
    @Input() creditMemoDetails;
    @Input() showCreditVoidMsg;
    @Input() templates;
    @Input() visibleFromModule;
    @Output() onAccountView = new EventEmitter();

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    fieldTypes = CustomAttributeFieldType;
    cols = 0;
    customFields = {
        billing_address_item: [],
        shipping_address_item: [],
        misc_item: [],
        section_item: [],
        footer_item: [],
        message_item: [],
        other1_item: [],
        other2_item: [],
        other3_item: [],
    };
    trackingDetails = [];
    notMatchedTrackingDetails=[];
    today = new Date();
    voidDate: string;
    allCustomAttributes = [];
    allModules = [];
    orderObjId;
    billingAddress;
    shippingAddress;
    shippingAddressContact;
    billingAddressContact;
    purchaseList = [];
    discounts = [];
    displayAppliedAmountViewModal = false;
    soChannel = SOChannel;
    filteredSection: any[] = [];
    sanitizedHtml: SafeHtml;

    /** Write Check */
    selectedFinance = {
        id: 0,
        name: "bank",
    };
    displayWriteCheck = false;
    writeCheckOptionFor = [CreditMemoStatus.Open, CreditMemoStatus.PartiallyApplied];
    cmDetails: any = null;

    totalAmount: number = 0;
    productsTotalAdditionalAmount: number = 0;

    // fraction digits
    fractionDigits: number = 0;
    qtyFractionDigits: number = 0;

    // currency
    baseCurrency: any;
    orgCurrency = [];
    currencyExchangeRate: any;
    savedCurrencyExchangeRate: any;

    glApiCall = false;
    transactionTypeIds = AccountsTransactionType;
    creditMemoId: number;
    isAllowPostingPeriod: boolean = false;

    constructor(
        public app: AppMainComponent,
        private utilityService: UtilityService,
        private datePipe: DatePipe,
        private appMainService: AppMainService,
        private productsService: ProductsService,
        private salesOrderService: SalesOrderService,
        private importService: ImportserialService,
        private sanitizer: DomSanitizer,
    ) {}

    ngOnInit() {
        this.getIsettings();
        this.getFractionDigits();
        this.getQtyDecimalDigits();
        this.getBaseCurrency();
        this.allModules = this.app.preLoadedObjects.filter((obj) => obj.name == "Orders");
        this.orderObjId = this.allModules.find((el) => el.name == "Orders")?.id;
        this.getAllCustomAttributes();
        this.utilityService.getFilteredSectionsByType(6).subscribe((res) => {
            this.filteredSection = res;
        });

        this.salesOrderService.getAllOrdersChannel("Orders Template").subscribe((configs) => {
            let allTemplates = JSON.parse(configs.configurationDetails[0].configJSONValue);
            this.templates = allTemplates?.filter((t) => t.typeId == TemplateType.CreditMemo)[0];
            this.getColsCount();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.voidDate = this.datePipe.transform(Date.now(), "MM-dd-yyyy");
        if (changes.creditMemoDetails && changes.creditMemoDetails.currentValue) {
            this.creditMemoId = this.creditMemoDetails.id;
            this.creditMemoDetails = changes.creditMemoDetails.currentValue;
            this.prepareCreditMemoDetailsData();
        }
        this.getColsCount();
    }

    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if(value){
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }
    getQtyDecimalDigits() {
        this.importService
            .getQtyDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.qtyFractionDigits = value;
                }
            });
    }

    getBaseCurrency() {
        this.importService
            .getOrgCurrency()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.baseCurrency = value.find((cr) => cr.isBaseCurrency);
                    this.orgCurrency = value;
                }
            });
    }

    prepareCreditMemoDetailsData(){
        this.salesOrderService.getAllGroups().subscribe((res) => {
            const disGroupId = res.filter((r) => r?.name?.toLowerCase() == "discount type")[0].id;
            this.salesOrderService.getDiscounts(false).subscribe((res) => {
                this.discounts = res;
                this.prepareCreditMemoDetails();
            });
        });
    }
    prepareCreditMemoDetails() {
        this.creditMemoDetails.creditMemoDate = this.app._showDateTimeWithZone(this.creditMemoDetails?.creditMemoDate);
        this.creditMemoDetails.postingDate = this.app._showDateTimeWithZone(this.creditMemoDetails?.postingDate);
        this.creditMemoDetails.expiryDate = this.app._showDateTimeWithZone(this.creditMemoDetails?.expiryDate);
        this.templates = this.creditMemoDetails && this.creditMemoDetails.configJSON ? JSON.parse(this.creditMemoDetails.configJSON) : this.templates;
        this.customFields = this.utilityService.getCreditMemoCustomAttributes(this.templates, this.allCustomAttributes);
        this.savedCurrencyExchangeRate = Number(this.creditMemoDetails.exchangeRate);
        // address & contact
        this.billingAddress = this.creditMemoDetails?.account?.accountAddresses?.filter((d) => d.addressId == this.creditMemoDetails.billingAddressId)[0]; // billing address
        this.shippingAddress = this.creditMemoDetails?.account?.accountAddresses?.filter((d) => d.addressId == this.creditMemoDetails.shippingAddressId)[0]; // shipping address
        this.billingAddressContact = this.creditMemoDetails?.contact;
        this.shippingAddressContact = this.creditMemoDetails?.shipContact;
        this.purchaseList = this.utilityService.parseCreditMemoProductsListForOverview(this.creditMemoDetails, this.discounts);
        this.trackingDetails = this.utilityService.getCreditMemoProductsSerialDetails(this.purchaseList);
        this.notMatchedTrackingDetails = this.creditMemoDetails.notMatchedSerialNumbers;

        // populate saved custom field data
        Object.keys(this.customFields).forEach((key) => {
            const dataArr = this.customFields[key];
            if (dataArr && dataArr.length > 0) {
                dataArr.forEach((element) => {
                    const filteredCustom = this.creditMemoDetails.customAttributeValues.filter((c) => c.customAttributeId == element.id)[0];
                    if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "InputBox") {
                        element.value = filteredCustom.value;
                    } 
                    else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Decimal") {
                        element.value = filteredCustom.value;
                    } 
                    else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Number") {
                        element.value = filteredCustom.value;
                    } 
                    else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DatePicker") {
                        element.value = this.datePipe.transform(filteredCustom.value, "MM/dd/yyyy");
                    } else if (filteredCustom && (filteredCustom.customAttribute?.formControl?.name == "FileUpload" || filteredCustom.customAttribute?.formControl?.name == "Picture")) {
                        element.customUploadedFiles = [];
                        filteredCustom.customeAttachement.forEach((el) => {
                            element.customUploadedFiles.push(el);
                        });
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "Rating") {
                        element.value = filteredCustom.ratingId;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "ToggleButton") {
                        element.value = filteredCustom.toggle;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "DropDownList") {
                        element.value = filteredCustom.values;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "RadioButton") {
                        element.value = filteredCustom.values.name;
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "CheckBox") {
                        element.value = [];
                        filteredCustom.multipleValues.forEach((el) => {
                            element.value.push(el.name);
                        });
                    } else if (filteredCustom && filteredCustom.customAttribute?.formControl?.name == "MultipleDropDownList") {
                        element.value = [];
                        filteredCustom.multipleValues.forEach((el) => {
                            element.value.push(el);
                        });
                    }
                });
            }
        });

        this.cmDetails = _.cloneDeep(this.creditMemoDetails);
        this.calculateTotalAmount();
        this.calculateProductsTotalAdditionalAmount();
    }
    calculateTotalAmount(){
        this.totalAmount = this.cmDetails?.creditMemoProducts?.reduce((total, item) => total + Number(item?.totalAmount), 0);
    }

    calculateProductsTotalAdditionalAmount() {
        const getAdditionalAmount = (item) => {
            let total = item?.product?.typeId == 4 ? 0 : Number(item?.additionalAmount) || 0;
            if (item?.creditMemoBundleDetail && item.creditMemoBundleDetail?.length > 0) {
                total += item.creditMemoBundleDetail.reduce((sum, bundleItem) => {
                    return sum + getAdditionalAmount(bundleItem);
                }, 0);
            }
            return total;
        };
    
        this.productsTotalAdditionalAmount = this.cmDetails?.creditMemoProducts?.reduce((total, item) => {
            return total + getAdditionalAmount(item);
        }, 0) || 0;
    }

    getAllCustomAttributes() {
        this.appMainService.isShowSpinner("loadCustomAttributes");
        this.productsService.getAllCustomFields(this.orderObjId).then((fields) => {
            this.allCustomAttributes = _.cloneDeep(fields);
            this.appMainService.isHideSpinner("loadCustomAttributes");
        });
    }

    getAllGroup() {
        this.salesOrderService.getAllGroups().subscribe((res) => {
            const disGroupId = res.filter((r) => r?.name?.toLowerCase() == "discount type")[0].id;
            this.getAllDiscountByGroupId(disGroupId);
        });
    }

    getAllDiscountByGroupId(groupId) {
        this.salesOrderService.getGroupById(groupId).subscribe((res) => {
            this.discounts = res;
        });
    }

    getFormattedData(field) {
        if (field && field?.value && field?.value.length > 0) {
            let d = "";
            field.value.forEach((f) => {
                d += f.name + ",";
            });
            return d.substring(0, d.length - 1);
        } else {
            return "";
        }
    }

    getColsCount() {
        this.cols = 0;
        if (this.templates && this.templates.labels_table) {
            this.templates.labels_table.forEach((e) => {
                this.cols += e && e.isChecked ? 1 : 0;
            });
        }
    }

    onAccountViewClick(e) {
        this.onAccountView.emit({ id: e?.account?.id ?? 0, channelId: e?.channelId });
    }

    onAppliedAmountViewClick() {
        this.displayAppliedAmountViewModal = true;
    }

    onCloseAppliedAmountModal() {
        this.displayAppliedAmountViewModal = false;
    }

    /** Write check */
    showWriteCheck(){
        this.displayWriteCheck = true;
    }
    closeWriteCheck(){
        this.displayWriteCheck = false;
        this.salesOrderService.getCreditMemoById(this.creditMemoDetails.id).subscribe((res) => {
            this.creditMemoDetails = res;
            this.prepareCreditMemoDetailsData()
        });
    }
    /** End Write check */
    		
    // find section by code
    getFilteredSectionsByType(code: string): string {     
        return this.filteredSection?.find((s) => s.code == code)?.name ?? "";
    }

    onTabChange(event){
        if(event.index == 1){
            this.glApiCall = true;
        }
        else{
            this.glApiCall = false;
        }
    }

    getSanitizedHtml(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
    getIsettings(){
        const iSettings = this.utilityService.getISettings();
        this.isAllowPostingPeriod = iSettings?.find((obj) => obj.code === "posting")?.enabled ?? false;
    }
}
